module.exports = __webpack_public_path__ + "img/header_contact.60055644.png";